<template>
    <div id="app">
        <header>
            <div id="nav">
                <b-navbar toggleable="lg" type="light" variant="mdh">
                    <b-navbar-brand>
                        <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
                    </b-navbar-brand>
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav style="flex-grow: 0 !important;" >
                        <b-navbar-nav>
                            <b-nav-item href="/home" v-if="authenticated && hasRole && $route.name != 'timeout' && $route.name == '/'">Home</b-nav-item>
                            <b-nav-item href="/hce/home" v-if="authenticated && hasRole && $route.name != 'timeout' && $route.path.includes('/hce') && $route.name != 'hcecreateProfile'">Home</b-nav-item>
                            <b-nav-item href="/home" v-if="authenticated && hasRole && $route.name != 'timeout' && $route.name == 'home'">Home</b-nav-item>
                            <b-nav-item @click="logout" v-if="authenticated && hasRole && $route.name != 'timeout'" tabindex=0 >Log out</b-nav-item>
                            <b-nav-item @click="login" v-if="!authenticated || !hasRole || $route.name == 'timeout'" tabindex=0>Log in</b-nav-item>
                            <b-nav-item @click="showTips()" v-if="!$route.path.includes('/hce')">User Tips</b-nav-item>

                        </b-navbar-nav>
                    </b-collapse>
                </b-navbar>
            </div>
        </header>
        <ModalIdle v-if="isIdle" />

        <main id="main-content">
            <b-container fluid>
                <router-view/>
            </b-container>
        </main>

        <div class="mt-5">
            <hr/>
            <div class="fluid-container footer">
                <p class="text-center" style="font-size:.85em;">Version: {{appVersion}}</p>
            </div>
        </div>

        <div>
            <form @submit.prevent="submit" id="formData">
                <b-modal id="modal-tips" size="xl" no-close-on-backdrop hide-footer scrollable @hide="reset">
                    <template slot="modal-header">
                        <h1>User Tips</h1>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </template>
                    <div class="container-fluid">
                        <h2>Login failure/Lock out</h2>
                        <ul>
                            <li>After 3 failed login attempts the user will be locked out</li>
                            <li>Lock out is for 24 hours</li>
                            <li>Contact <a href="mailto:health.drmreport@state.mn.us">health.drmreport@state.mn.us</a>  for assistance/reset</li>
                        </ul>
                        <h2>Password Requirements</h2>
                        <p> Your password must contain at least one of each of the following and be at least 12 characters long:    </p>
                        <ul>
                            <li>Lowercase character</li>
                            <li>Uppercase character</li>
                            <li>Special character</li>
                            <li>Number</li>
                        </ul>

                        <h2>Helpful Tips</h2>
                        <p> This web interface allows for the update of company and contact information as well as the upload of your Excel HPFSR report.</p>

                        <ul>
                            <li>Please provide a valid company mailing address.</li>
                            <li>Preparer's contact information is required.</li>
                            <li>Courtesy contacts can be added at your discretion.</li>
                            <li>Editable fields will outline in blue when in focus.</li>
                            <li>Required fields will outline in red if not completed.</li>
                            <li>Uploaded files are restricted to PDF files and Excel (.xlsx or .xls) files and no larger than 2MB.</li>
                            <li>To upload files use navigation or drag and drop.</li>
                        </ul>

                        <h2>Formset and Instructions</h2>
                        <p>Visit the <a href="https://health.state.mn.us/hpfsr" target="_blank">Health Plan Reporting Requirements</a> site </p>
                        <ul>
                            <li>Please download and save the HPFSR Formset and Instructions.</li>
                            <li>Please review the Tip Sheet tab of the formset for information about completing the HPFSR report.</li>
                        </ul>

                        <h2>Legislative Authority</h2>
                        <p><a href="https://www.revisor.mn.gov/statutes/cite/62J.38" target="_blank">Minnesota Statutes 62J.38</a></p>
                        <p><a href="https://www.revisor.mn.gov/statutes/cite/62J.321" target="_blank">Minnesota Statutes 62J.321</a></p>
                        <p><a href="https://www.revisor.mn.gov/rules/4652/" target="_blank">Minnesota Rules, chapter 4652</a></p>

                        <h2>Contact Information</h2>
                        <p><a href="mailto:health.drmreport@state.mn.us">health.drmreport@state.mn.us</a></p>
                        <p>651-201-3572</p>
                    </div>

                    <b-row style="padding-top: 10px;">
                        <b-col>
                            <b-button @click="close" style="margin-right:15px;">Close</b-button>
                        </b-col>
                    </b-row>
                </b-modal>
            </form>
        </div>
    </div>
</template>

<script>
import LocalStorageService from '@/common/LocalStorageService';
import {version} from '../package.json';
import Sweetalert from 'sweetalert';
import Swal from 'sweetalert';
import ModalIdle from '@/components/ModalIdle'
import lambdaURL from "@/lambda";

export default {
    components: {
        ModalIdle
    },
    metaInfo: {
        title: 'Welcome',
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    },
    computed: {
        authenticated: function() {
            if (this.$keycloak) {
                return this.$keycloak.authenticated;
            } else {
                return false;
            }
        },
        appVersion: function() {
            return version;
        },
        isIdle() {
            return this.$store.state.idleVue.isIdle;
        }
    },
    methods: {
        login () {
            const localStorageService = LocalStorageService.getService();
            localStorageService.clearAuthTokens();
            const loginUrl = this.$keycloak.createLoginUrl()
            window.location.replace(loginUrl)
        },
        logout() {
            const localStorageService = LocalStorageService.getService()
            localStorageService.clearAuthTokens()
            this.$store.dispatch('resetState')
            this.$keycloak.clearToken()
            this.$keycloak.logoutFn()
        },
        hasRole(roles) {
           console.log(JSON.stringify(roles));
            if (this.$keycloak) {
                //return this.$keycloak.hasResourceRole(roles)
                return true;
            } else {
                return false;
            }
        },
        showTips() {
            this.$bvModal.show('modal-tips')
        },
        close () {
            this.$bvModal.hide('modal-tips')
        },
    },
}
</script>

<style lang="scss">
@import "assets/_custom.scss";
@import "vue-select/src/scss/vue-select.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
#app {
    font-family: 'Open Sans', Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

h1 {
    font-size: 30px;
    font-weight: 600;
}

h2 {
    font-size: 24px;
    font-weight: 600;
}

h3 {
    font-size: 18px;
    font-weight: 600;
}

button {
    margin-right: 18px;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

.bg-mdh {
    background-color: rgb(0, 56, 101);
}

#nav {
    padding-bottom: 30px;
}

#nav a {
    font-weight: normal;
    color: white;
}

#nav a.router-link-exact-active {
    color: #42b983;
}

#nav  a.dropdown-item {
    color: black !important;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
}

.colWidth40 {
    width: 40%;
}

.is-invalid .d-block {
    color: #ef0000;
}

.label-required::after {
    color: #0a8927;
    font-size: .7em;
    text-transform: uppercase;
    margin-left: 19px;
    content:" required";

}

.hec-label-required::after {
    color: #0a8927;
    font-size: .9em;
    margin-left: .5rem;
    content: "(required)";
}

.wizard-card-footer div span {
    outline: none;
}

.wizard-card-footer div span:focus button {
    -webkit-box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
    box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
}

.wizard-nav li:has(.disabled) {
    user-focus: none;
}

li.plan {
    display: inherit;
    margin: 10px 10px;
}

ul {
    list-style-type: disc !important;
}

li {
    display: list-item !important;
    margin: 0 30px;
}

</style>
